// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m["default"] || m;
};

exports.components = {
  "component---src-templates-api-page-js": function componentSrcTemplatesApiPageJs() {
    return import("/usr/local/lib/node_modules/@toast-ui/doc/src/templates/api-page.js"
    /* webpackChunkName: "component---src-templates-api-page-js" */
    );
  },
  "component---src-templates-example-page-js": function componentSrcTemplatesExamplePageJs() {
    return import("/usr/local/lib/node_modules/@toast-ui/doc/src/templates/example-page.js"
    /* webpackChunkName: "component---src-templates-example-page-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("/usr/local/lib/node_modules/@toast-ui/doc/src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  }
};